import i18next from 'i18next';
import isEmpty from 'lodash/isEmpty';

import { bulkPanels } from 'common/api/v1/panelsCompanies';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
} from '../actionTypes';
import { panelsActions } from '../reducer';

import filterItems from './filterPanels';

export default (ids, value, filterData, callback) => (dispatch) => {
    dispatch(panelsActions[BULK_UPDATE_ITEMS]());

    const newValues = {
        panels: ids,
        status_flag: value,
    };

    bulkPanels(newValues)
        .then(() => {
            dispatch(panelsActions[BULK_UPDATE_ITEMS_SUCCESS]());
            if (!isEmpty(filterData)) dispatch(filterItems(filterData));
            if (value === 'deleted')
                showToast({ body: i18next.t('It was successfully removed') });
            if (value === 'archived')
                showToast({ body: i18next.t('It was successfully archived') });
            if (value === 'active')
                showToast({
                    body: i18next.t('It was successfully unarchived'),
                });
            if (callback) callback();
        })
        .catch((error) => {
            dispatch(
                panelsActions[BULK_UPDATE_ITEMS_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
